import cepPromise, { type CEP } from 'cep-promise';
import { useEffect, useState } from 'react';

import useDebounce from '../useDebounce';

const useCEP = (cepValue: string | number = '') => {
  const [address, setAddress] = useState<CEP | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const debouncedCEP = useDebounce(cepValue.toString().replace(/\D/g, ''), 500);

  useEffect(() => {
    if (debouncedCEP.length === 8) {
      setLoading(true);
      cepPromise(debouncedCEP)
        .then((address) => {
          setAddress(address);
          setError(null);
        })
        .catch((error) => {
          setAddress(null);
          setError('Por favor, insira um CEP válido.');
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setAddress(null);
      setError(null);
    }
  }, [debouncedCEP]);

  return { address, error, loading };
};

export default useCEP;
